// src/plugins/vuetify.js

import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify, {
  theme: {
    themes: {
      light: {
        primary: '#5164A4',
        secondary: '#88D2FA',
      },
    },
  },
});

const opts = {};

export default new Vuetify(opts);
